var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.5 8.8l-12 12c-2.6 2.6-2 7.4.6 9.9l.7.7c2.6 2.6 6.9 3.1 10.1.7L35.1 17c1.2-1.2 0-2.6 0-2.6l-5-5c-.7-.7-2-.7-2.7 0L13.2 23.6c-1.1 1.1-1.1 2.8 0 3.8 1.1 1.1 2.8 1.1 3.8 0l11.2-11.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.5 8.8l-12 12c-2.6 2.6-2 7.4.6 9.9l.7.7c2.6 2.6 6.9 3.1 10.1.7L35.1 17c1.2-1.2 0-2.6 0-2.6l-5-5c-.7-.7-2-.7-2.7 0L13.2 23.6c-1.1 1.1-1.1 2.8 0 3.8 1.1 1.1 2.8 1.1 3.8 0l11.2-11.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f59e6a9852e74830ffb6690189a21649.svg";
export { ForwardRef as ReactComponent };